import { SVGProps, Ref, forwardRef } from 'react';

export const UturnLeftOutlinedSize16Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={16} height={16} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <g>
                <path
                    d="M6.323 1.49 5.333.5.5 5.333l4.833 4.834.99-.99L3.18 6.033h6.888a4.035 4.035 0 1 1 0 8.07H2v1.4h8.068a5.435 5.435 0 1 0 0-10.87H3.18z"
                    fill="currentColor"
                />
            </g>
        </g>
    </svg>
));
UturnLeftOutlinedSize16Glyph.displayName = 'UturnLeftOutlinedSize16Glyph';
